<script lang="ts">
  import { mdiEmailOutline, mdiNoteTextOutline, mdiMinusCircleOutline } from "@mdi/js"
  import ToggleCTA from "@kontextwerk/web-sdk/ui/actions/ToggleCTA.svelte"
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import type {
      InboxWorkflowCellProps,
      InboxWorkflowJson,
  } from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
  import type { LetterSelectionDraft, LetterSelectionRow } from "../../contract"
  import {
    printRowKey,
    printStrategyForState,
    setRowStrategy,
    strategyToggleOptionsForRow,
  } from "../../../../_shared/_logic/print-selection"

  let props: InboxWorkflowCellProps<LetterSelectionRow, LetterSelectionDraft> = $props()

  const printRow = $derived(props.row)
  const state = $derived(props.draft)
  const value = $derived(printStrategyForState(state))
  const options = $derived(
    strategyToggleOptionsForRow(printRow).map((option) => ({
      ...option,
      icon:
        option.value === "IGNORE"
          ? mdiMinusCircleOutline
          : option.value === "NOTICE"
            ? mdiNoteTextOutline
            : mdiEmailOutline,
    })),
  )

  const handleChange = (next: string) => {
    const rowId = printRowKey(printRow)
    const updated = setRowStrategy(
      { [rowId]: state },
      printRow,
      next === "IGNORE" ? "IGNORE" : next === "NOTICE" ? "NOTICE" : "LETTER",
    )
    props.patchDraft(updated[rowId] as unknown as InboxWorkflowJson)
  }
</script>

<TableFormCell>
  {#if printRow.statusLabel === "Datenfehler"}
    <span class="letter-print-empty">—</span>
  {:else}
    <ToggleCTA
      {options}
      {value}
      class="letter-print-strategy-toggle"
      small={true}
      darkMode={false}
      disabled={props.binding.disabled}
      onChange={(next) => handleChange(String(next))}
    />
  {/if}
</TableFormCell>

<style>
  .letter-print-empty {
    color: var(--text-invers-100);
  }

  :global(.letter-print-strategy-toggle) {
    min-width: max-content;
  }

  :global(.letter-print-strategy-toggle button.cta.toggle) {
    white-space: nowrap;
  }
</style>
